import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr'
import Configuration from '../utils/configuration'
import {mapGetters} from "vuex";

export default {
  name: "DashboardHub",
  computed: {
    ...mapGetters(['token']),
  },
  methods: {
    async connectDashboardHub() {
      try {
        const connection = new HubConnectionBuilder()
          .withUrl(`${Configuration.value('backendHost')}/hubs/dashboard-hub`, {accessTokenFactory: () => this.token})
          .withAutomaticReconnect()
          .build();

        await connection.start();

        connection.on('BookingUpdate', () => {
          this.handleBookingUpdate();
        })
      } catch (error) {
        this.dangerAlert("Websocket connection failed")
      }
    }
  }
}